<template>
  <div class="region-global">
    <div class="content margin-general">
      <h2 v-if="$t('RegionGlobal.titleSeccion')" class="textMobile">{{ $t("RegionGlobal.titleSeccion") }}</h2>
      <p v-if="$t('RegionGlobal.descSeccion')" class="body-4 descSeccion textMobile">
        {{ $t("RegionGlobal.descSeccion") }}
      </p>
      <div class="img-countries">
        <template v-for="(row, index) in categories[selected]" :key="index">
          <div
            v-if="
              activeIndex === index ||
              selected === 'tvweu' ||
              selected === 'tvmidle'
            "
          >
            <img
              :src="item.imgSeccion"
              :alt="item.alt"
              v-for="(item, itemIndex) in row"
              :key="itemIndex"
            />
          </div>
        </template>
      </div>

      <div class="img-countries-sm">
        <div>
          <img
            src="/images/regulation/Cayman.webp"
            alt="Tradeview is a fully licensed Broker/Dealer under the regulations of the Cayman Island Monetary"
          />
        </div>
      </div>
      <div class="content-dropdowns">
        <h2 v-if="$t('RegionGlobal.titleSeccion')" class="textDesktop">{{ $t("RegionGlobal.titleSeccion") }}</h2>
        <p v-if="$t('RegionGlobal.descSeccion')" class="body-4 descSeccion textDesktop">
          {{ $t("RegionGlobal.descSeccion") }}
        </p>
        <div class="buttonsContainer" ref="buttonsContainer">
          <button
            v-for="tab in tabs"
            :key="tab.name"
            class="buttonItem"
            :class="{ selected: selected === tab.value }"
            @click="selectTab(tab.value)"
          >
            {{ $t(tab.label) }}
          </button>

          <span class="selected-border" :style="borderStyle">
            <div class="border-style"></div>
          </span>
        </div>
        <div
          class="card-content"
          v-for="(row, index) in categories[selected]"
          :key="row.index"
        >
          <div
            v-for="item in row"
            :key="item"
            class="box"
            :class="
              activeIndex === index ||
              selected === 'tvweu' ||
              selected === 'tvmidle'
                ? 'active'
                : ''
            "
            @click="setActive(index)"
          >
            <div class="box-body">
              <div class="box-title">
                <h4 v-if="item.titleTab && $t(item.titleTab)" class="title body-6">{{ $t(item.titleTab) }}</h4>
                <img
                  v-if="totalAcordeones > 1"
                  src="/images/small-down.svg"
                  :alt="item.alt"
                  :class="activeIndex === index ? 'rotated' : ''"
                />
              </div>
              <div
                v-if="
                  activeIndex === index ||
                  selected === 'tvweu' ||
                  selected === 'tvmidle'
                "
                class="box-text"
              >
                <p v-if="item.descTab && $t(item.descTab)" class="body-4">{{ $t(item.descTab) }}</p>
                <p v-if="item.address && $t(item.address)">
                  <span class="body-4-bold">{{
                    $t("regulation.modal.headquarters")
                  }}</span>
                  {{ $t(item.address) }}
                </p>
                <p v-if="item.websiteName && $t(item.websiteName) && item.websitelink">
                  <span class="body-4-bold"
                    >{{ $t("regulation.modal.website") }}
                  </span>
                  <a :href="item.websitelink" target="_blank" class="link-4" rel="noopener noreferrer">{{
                    $t(item.websiteName)
                  }}</a>
                </p>
                <a
                  v-if="shouldShowButton(item.visibleLangs, item.defaultVisibility) && item.buttonText && $t(item.buttonText) && item.buttonLink"
                  :href="item.buttonLink"
                  class="second-button-medium caption-1-bold"
                  target="_blank"
                 rel="noopener noreferrer">
                  {{ $t(item.buttonText) }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n';
import SelectCustom from "../utils/select/SelectCustom.vue";
import { useNuxtApp } from '#app';

export default {
  name: "region global",
  components: {
    SelectCustom,
  },
  setup() {
    const { $regulationsVar } = useNuxtApp();
    const { locale } = useI18n();
    const regulation = ref($regulationsVar.getRegulation(locale.value));

    const shouldShowButton = (visibleLangs, defaultVisibility) => {
      const currentLang = locale.value;
      const currentRegulation = $regulationsVar.getRegulation(currentLang);
      if (visibleLangs.includes(currentLang) || visibleLangs.includes(currentRegulation)) {
        return true;
      }
      return defaultVisibility;
    };

    return {
      locale,
      regulation,
      shouldShowButton
    };
  },
  data() {
    return {
      activeIndex: "tvwltd",
      selected: "americas",
      tabs: [
        { value: "tvweu", label: "RegionGlobal.europe.titleTab" },
        { value: "americas", label: "RegionGlobal.americas.titleTab" },
        { value: "tvmidle", label: "RegionGlobal.Middle.titleTab" },
        // { value: "tvwuk", label: "RegionGlobal.uk.titleTab" },
      ],
      selectedButtonIndex: 0,
      borderStyle: {},
      categories: {
        americas: {
          tvwltd: [
            {
              imgSeccion: "/images/regulation/Cayman.webp",
              alt: "Tradeview is a fully licensed Broker/Dealer under the regulations of the Cayman Island Monetary",
              titleTab: "RegionGlobal.americas.items.tvwltd.titleDropdown",
              descTab: "RegionGlobal.americas.items.tvwltd.descDropdown",
              address: "RegionGlobal.americas.items.tvwltd.address",
              websiteName: "RegionGlobal.americas.items.tvwltd.website",
              websitelink: "https://www.tvmarkets.com/",
              buttonText: "RegionGlobal.btn",
              buttonLink: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/ListSIBLLicensees.pdf",
              visibleLangs: ["LATAM"],
              defaultVisibility: false, 
            },
          ],
          fiancialGlobal: [
            {
              imgSeccion: "/images/regulation/PeruImg.png",
              alt: "Tradeview is authorized to conduct business pursuant to and in compliance with the General Law of Companies (LGS) promulgated by the government of Peru",
              titleTab:
                "RegionGlobal.americas.items.fiancialGlobal.titleDropdown",
              descTab:
                "RegionGlobal.americas.items.fiancialGlobal.descDropdown",
              address: "RegionGlobal.americas.items.fiancialGlobal.address",
              websiteName: "RegionGlobal.americas.items.fiancialGlobal.website",
              websitelink: "https://www.tradeviewlatam.com/",
              buttonText: "RegionGlobal.btn",
              buttonLink: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/Partida+Registral+-+TV+MARKETS+SAC+(1).pdf",
              visibleLangs: ["LATAM"],
              defaultVisibility: false, 
            },
          ],
          tvmGlobal: [
            {
              imgSeccion: "/images/regulation/Labuan.png",
              alt: "Tradeview is licensed and regulated by the Labuan Financial Services Authority (FSA) as a Money Broker",
              titleTab: "RegionGlobal.americas.items.tvmGlobal.titleDropdown",
              descTab: "RegionGlobal.americas.items.tvmGlobal.descDropdown",
              address: "RegionGlobal.americas.items.tvmGlobal.address",
              websiteName: "RegionGlobal.americas.items.tvmGlobal.website",
              websitelink: "https://www.tvmgloballtd.com/",
              buttonText: "RegionGlobal.btn",
              buttonLink: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/TVM+Global+Limited-LFSA+License-Money+Brokering+Business-No.-MB-19-0037-notarized.pdf",
              visibleLangs: ["LATAM"],
              defaultVisibility: false, 
            },
          ],
          ilcBrokers: [
            {
              imgSeccion: "/images/regulation/Mauritius.png",
              alt: "Tradeview is authorized under the Mauritius Financial Service Commission",
              titleTab: "RegionGlobal.americas.items.ilcBrokers.titleDropdown",
              descTab: "RegionGlobal.americas.items.ilcBrokers.descDropdown",
              address: "RegionGlobal.americas.items.ilcBrokers.address",
              websiteName: "RegionGlobal.americas.items.ilcBrokers.website",
              websitelink: "https://www.ilcbrokers.com/en",
              buttonText: "RegionGlobal.btn",
              buttonLink: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/iLC+Brokers+Ltd-Investment+Dealer+Licence+December+17%2C+2020.pdf",
              visibleLangs: ["LATAM"],
              defaultVisibility: false, 
            },
          ],
        },
        tvweu: {
          europe: [
            {
              imgSeccion: "/images/regulation/Europe.png",
              alt: "Tradeview Is licensed as a Category 2 Investment Service Company and is regulated by the Malta Financial Services Authority (MFSA).",
              titleTab: "RegionGlobal.europe.items.tvwEU.titleDropdown",
              descTab: "RegionGlobal.europe.items.tvwEU.descDropdown",
              address: "RegionGlobal.europe.items.tvwEU.address",
              websiteName: "RegionGlobal.europe.items.tvwEU.website",
              websitelink: "https://tradeview.eu/",
              buttonText: "RegionGlobal.btn",
              buttonLink: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/Tradeview+Europe+Limited-Category+2+License+Certificate.pdf",
              visibleLangs: ["LATAM"],
              defaultVisibility: false, 
            },
          ],
        },
        tvmidle: {
          europe: [
            {
              imgSeccion: "/images/regulation/Middle-east.png",
              alt: "",
              titleTab: "RegionGlobal.Middle.items.tvwmiddle.titleDropdown",
              descTab: "RegionGlobal.Middle.items.tvwmiddle.descDropdown",
              visibleLangs: ["LATAM"],
              defaultVisibility: false, 
            },
          ],
        },
        // tvwuk: {
        //   tvwltd: [
        //     {
        //       imgSeccion: "/images/regulation/UK.png",
        //       alt: "TVCM Ltd is a limited company registered in England and Wales by Xprime Markets Limited FCA FRN",
        //       titleTab: "RegionGlobal.uk.items.tvwUK.titleDropdown",
        //       descTab: "RegionGlobal.uk.items.tvwUK.descDropdown",
        //       address: "RegionGlobal.uk.items.tvwUK.address",
        //       websiteName: "RegionGlobal.uk.items.tvwUK.website",
        //       websitelink: "https://www.tradeview.co.uk/",
        //       buttonText: "RegionGlobal.uk.items.tvwUK.buttonText",
        //       buttonLink: "https://documents-tvmarkets.s3.us-west-1.amazonaws.com/Tradeview+Ltd-+Certificate+Of+Incumbency+-+April+2023+(2).pdf",
        //       visibleLangs: ["es-co", "es-ar", "es-mx"],
        //       defaultVisibility: true,
        //     },
        //   ],
        // },
      },
    };
  },

  computed: {
    totalAcordeones() {
      const grupos = this.categories[this.selected];
      if (!grupos) return 0;
      return Object.values(grupos).reduce((acc, arr) => acc + arr.length, 0);
    }
  },

  mounted() {
    this.initializeBorderBottomStyle();
    this.selected = "tvweu";
  },

  methods: {
    selectTab(tabName) {
      const newIndex = this.tabs.findIndex((tab) => tab.value === tabName);
      if (newIndex !== -1) {
        this.selected = tabName;
      }
      this.selectedButtonIndex = newIndex;
      this.updateBorderBottomStyle();
    },

    initializeBorderBottomStyle() {
      const button =
        this.$refs.buttonsContainer.children[this.selectedButtonIndex];
      if (button) {
        this.borderStyle = {
          width: `${button.offsetWidth}px`,
          left: `${button.offsetLeft}px`,
        };
      }
    },

    updateBorderBottomStyle() {
      const button =
        this.$refs.buttonsContainer.children[this.selectedButtonIndex];
      if (button) {
        this.borderStyle = {
          width: `${button.offsetWidth}px`,
          left: `${button.offsetLeft}px`,
        };
      }
    },

    setActive(index) {
      this.activeIndex = index;
    },
  },
};
</script>